import React, { useState } from "react"
import { User, Mail, Lock, ArrowLeft, Sparkles, ShieldCheck, Loader2 } from "lucide-react"
import { Link } from "react-router"

export default function SingUpPage() {
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        // Simulate registration logic
        setTimeout(() => setIsLoading(false), 2000);
    };

    return (
        <div className="min-h-screen bg-premium-dark flex items-center justify-center p-6 relative overflow-hidden font-poppins">
            {/* Dynamic Background Elements */}
            <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-premium-teal/20 rounded-full blur-[120px] animate-pulse-slow"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-premium-gold/10 rounded-full blur-[120px] animate-pulse-slow font-inter" style={{ animationDelay: '2s' }}></div>

            <div className="w-full max-w-[1100px] grid grid-cols-1 lg:grid-cols-2 bg-white/5 backdrop-blur-2xl rounded-[3rem] border border-white/10 shadow-2xl overflow-hidden relative z-10 animate-fade-in-up">

                {/* Left Side: Brand & Visuals */}
                <div className="hidden lg:flex flex-col justify-between p-16 bg-gradient-to-br from-premium-teal/40 to-transparent border-r border-white/5 relative">
                    <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"></div>

                    <div className="relative z-10">
                        <Link to="/" className="flex items-center gap-3 text-white mb-20 group">
                            <div className="w-10 h-10 rounded-xl bg-premium-gold flex items-center justify-center shadow-lg shadow-premium-gold/20 transform group-hover:rotate-12 transition-transform">
                                <Sparkles className="text-premium-dark" size={20} />
                            </div>
                            <span className="text-2xl font-black tracking-tighter uppercase">Saccoss<span className="text-premium-gold ml-1">Elite</span></span>
                        </Link>

                        <h1 className="text-6xl font-black text-white leading-tight tracking-tighter mb-8">
                            Forge Your <br />
                            <span className="premium-gradient-text">Financial Destiny</span>
                        </h1>
                        <p className="text-gray-400 text-lg font-medium leading-relaxed max-w-md">
                            Join the most sophisticated community of financial growth. Secure, transparent, and built for the modern sovereign.
                        </p>
                    </div>

                    <div className="relative z-10 flex items-center gap-6">
                        <div className="flex -space-x-4">
                            {[1, 2, 3, 4].map(i => (
                                <div key={i} className="w-12 h-12 rounded-full border-2 border-premium-dark bg-gray-800 flex items-center justify-center text-xs font-bold text-premium-gold">
                                    U{i}
                                </div>
                            ))}
                        </div>
                        <p className="text-sm font-bold text-gray-500 uppercase tracking-widest">+ 2.4k Active Sovereigns</p>
                    </div>
                </div>

                {/* Right Side: Registration Form */}
                <div className="p-10 lg:p-20 bg-white/5 relative">
                    <div className="max-w-md mx-auto">
                        <div className="flex justify-between items-center mb-12">
                            <div>
                                <h2 className="text-4xl font-black text-white tracking-tighter">Initialize</h2>
                                <p className="text-premium-gold text-[10px] font-black uppercase tracking-[0.3em] mt-1">Identity Protocol</p>
                            </div>
                            <Link to="/login" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors">
                                <span className="text-xs font-bold uppercase tracking-widest">Sign In</span>
                                <ArrowLeft size={16} className="rotate-180" />
                            </Link>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <label className="text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] ml-1">First Name</label>
                                    <div className="relative group">
                                        <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none text-gray-500 group-focus-within:text-premium-gold transition-colors">
                                            <User size={18} />
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="John"
                                            className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-14 pr-6 text-white font-bold text-sm focus:outline-none focus:ring-2 focus:ring-premium-gold/30 focus:border-premium-gold/50 transition-all placeholder:text-gray-600"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="space-y-2">
                                    <label className="text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] ml-1">Last Name</label>
                                    <input
                                        type="text"
                                        placeholder="Doe"
                                        className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 px-6 text-white font-bold text-sm focus:outline-none focus:ring-2 focus:ring-premium-gold/30 focus:border-premium-gold/50 transition-all placeholder:text-gray-600"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label className="text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] ml-1">Email Terminal</label>
                                <div className="relative group">
                                    <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none text-gray-500 group-focus-within:text-premium-gold transition-colors">
                                        <Mail size={18} />
                                    </div>
                                    <input
                                        type="email"
                                        placeholder="sovereign@elitesacco.com"
                                        className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-14 pr-6 text-white font-bold text-sm focus:outline-none focus:ring-2 focus:ring-premium-gold/30 focus:border-premium-gold/50 transition-all placeholder:text-gray-600"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <label className="text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] ml-1">Security Key</label>
                                <div className="relative group">
                                    <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none text-gray-500 group-focus-within:text-premium-gold transition-colors">
                                        <Lock size={18} />
                                    </div>
                                    <input
                                        type="password"
                                        placeholder="••••••••••••"
                                        className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-14 pr-6 text-white font-bold text-sm focus:outline-none focus:ring-2 focus:ring-premium-gold/30 focus:border-premium-gold/50 transition-all placeholder:text-gray-600"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="flex items-center gap-3 py-2">
                                <ShieldCheck className="text-premium-gold" size={20} />
                                <p className="text-[10px] font-bold text-gray-500 leading-relaxed uppercase tracking-widest">
                                    By committing, you agree to our <span className="text-white hover:text-premium-gold cursor-pointer underline transition-colors">Terms of Protocol</span>
                                </p>
                            </div>

                            <button
                                type="submit"
                                disabled={isLoading}
                                className="premium-button w-full bg-premium-teal text-white py-5 rounded-2xl font-black text-xs uppercase tracking-[0.3em] flex items-center justify-center gap-3 shadow-2xl shadow-premium-teal/30 group disabled:opacity-70"
                            >
                                {isLoading ? (
                                    <Loader2 className="animate-spin" size={20} />
                                ) : (
                                    <>
                                        Commit Membership
                                        <Sparkles size={18} className="text-premium-gold group-hover:rotate-12 transition-transform" />
                                    </>
                                )}
                            </button>
                        </form>

                        <div className="mt-12 pt-8 border-t border-white/5 flex items-center justify-center gap-4">
                            <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">Powered by Saccoss Quantum</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}